import { cls } from '@/ui/cls'
import { ModalShell, ModalHead, ModalSection, ModalLabel, ModalFoot } from '@/ui/Modal'
import { CALL_OUTCOMES, CALL_OUTCOME_LABEL, type CallDraft } from './columns'
import { Textarea } from '@/ui'

export default function CallLogModal({
  draft, setDraft, onCancel, onSave,
}: {
  draft: CallDraft
  setDraft: (d: CallDraft) => void
  onCancel: () => void
  onSave: () => void
}) {
  return (
    <ModalShell onClose={onCancel} narrow>
      <ModalHead
        eyebrow={`Logga samtalsförsök ${draft.index + 1}`}
        title={draft.company}
        onClose={onCancel}
      />

      <ModalSection>
        <ModalLabel>Utfall</ModalLabel>
        <div className="flex flex-wrap gap-1.5">
          {CALL_OUTCOMES.map(o => (
            <button
              key={o}
              type="button"
              className={cls(
                'px-2.5 py-1 text-[12px] rounded-[2px] border cursor-pointer transition-colors',
                draft.outcome === o
                  ? 'bg-ink-1000 text-paper border-ink-1000'
                  : 'bg-white text-ink-700 border-ink-200 hover:text-ink-1000 hover:border-ink-700',
              )}
              onClick={() => setDraft({ ...draft, outcome: o })}
            >
              {CALL_OUTCOME_LABEL[o]}
            </button>
          ))}
        </div>
      </ModalSection>

      <ModalSection>
        <ModalLabel>Anteckning</ModalLabel>
        <Textarea
          rows={3}
          placeholder="Vad hände under samtalet?"
          value={draft.note}
          onChange={e => setDraft({ ...draft, note: e.target.value })}
          autoFocus
        />
      </ModalSection>

      <ModalFoot
        onCancel={onCancel}
        onSave={onSave}
        saveDisabled={!draft.outcome}
        saveLabel="Logga samtal"
      />
    </ModalShell>
  )
}
